import { render, staticRenderFns } from "./ElectronicFenceInfo.vue?vue&type=template&id=47634852&scoped=true"
import script from "./ElectronicFenceInfo.vue?vue&type=script&lang=js"
export * from "./ElectronicFenceInfo.vue?vue&type=script&lang=js"
import style0 from "./ElectronicFenceInfo.vue?vue&type=style&index=0&id=47634852&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47634852",
  null
  
)

export default component.exports